import { z } from 'zod';
import { AccountIdSchema } from '../ids';
import { TimestampMsSchema } from '../time';

/** The person behind the characters: what signs in (ADR 0029). Never part of the world. */
export const AccountSchema = z.object({
  id: AccountIdSchema,
  createdAt: TimestampMsSchema,
});
export type Account = z.infer<typeof AccountSchema>;

/** Where an identity comes from. `dev` exists only with dev tools (local sign-in). */
export const IdentityProviderSchema = z.enum(['google', 'dev']);
export type IdentityProviderName = z.infer<typeof IdentityProviderSchema>;
